module.exports = __webpack_public_path__ + "img/startnow.09f1737b.jpg";